import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { GenFormBuilder } from "../../providers/form";

@Component({
  selector: "app-footer-suggestion",
  templateUrl: "footer-suggestion.html",
})
export class FooterSuggestionComponent implements OnInit {

  @Input() public form: FormGroup;
  @Input() public value: any = null;
  @Input() public defaultLanguage: string;
  @Input() public language: string;
  @Input() public submitAttempt: boolean;
  @Output() public languageChange = new EventEmitter();

  constructor(
    private formGenerate: GenFormBuilder,
  ) { }

  public ngOnInit() {
    this.formGenerate.genInputLang("tag", this.form, this.defaultLanguage);
    this.formGenerate.genInputLang("title", this.form, this.defaultLanguage, { es: "", en: "" }, false);
    this.formGenerate.genInputString("type", this.form, true);
    this.formGenerate.genInputString("background", this.form, false);

    if (this.value) {
      this.form.patchValue(this.value);
    }
  }

  public selected(event) {
    this.languageChange.emit(event);
  }
}



// WEBPACK FOOTER //
// ./src/components/footer-suggestion/footer-suggestion.ts